import PaginationButtons from './PaginationButtons';

export default PaginationButtons;
